export class APIConfig {
  readonly SERVER_PATH: string;
  readonly headers: Record<string, string>;

  /* istanbul ignore next */
  constructor(config: Partial<APIConfig>) {
    Object.assign(this, config);
  }
}

export const oAuthEndpointPath = {
  token: '/oauth2/token',
  revoke: '/oauth2/revoke'
};